import classNames from "classnames/bind";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import FontAwesome from "react-fontawesome";
import Breadcrumb from "./Breadcrumb";
import styles from "./Breadcrumbs.module.scss";
import type { CollapsibleBreadcrumbsProps } from "./types";

const cx = classNames.bind(styles);

const CollapsibleBreadcrumbs = ({
  breadcrumbs,
  isLoading,
}: CollapsibleBreadcrumbsProps) => {
  const [expanded, setExpanded] = useState(false);

  if (expanded) {
    return (
      <AnimatePresence>
        <motion.ol
          initial={{
            width: 0,
          }}
          transition={{ ease: "easeOut" }}
          animate={{ width: "auto" }}
          exit={{ width: "auto" }}
          className={cx("breadcrumbs")}
        >
          {breadcrumbs.map(({ title, ...restProps }) => (
            <Breadcrumb
              key={title}
              title={title}
              {...restProps}
              isLoading={isLoading}
            />
          ))}
        </motion.ol>
      </AnimatePresence>
    );
  } else {
    return (
      <li className={cx("item")}>
        <button
          className={cx("expandButton")}
          onClick={() => setExpanded(true)}
          disabled={isLoading}
        >
          ...
        </button>

        <FontAwesome
          className={`${cx("icon")} fa-fw`}
          name="angle-right"
        />
      </li>
    );
  }
};

export default CollapsibleBreadcrumbs;
